<template>
  <div class="common-accordion" @keydown.enter="toggleContent" tabindex="0">
    <div class="accordion-header-container" @click="toggleContent">
      <slot name="header"></slot>
      <pn-icon
        :symbol="showContent ? 'angle-small-up' : 'angle-small-down'"
        color="blue700"
        size="medium"
        solid
      ></pn-icon>
    </div>
    <div class="accordion-content-container" v-show="showContent">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    openDefault: {
      type: Boolean
    }
  },
  data() {
    return {
      showContent: false
    }
  },
  mounted() {
    this.showContent = this.openDefault || false
  },
  methods: {
    toggleContent() {
      this.showContent = !this.showContent
    }
  }
}
</script>

<style lang="scss">
.common-accordion {
  font-size: 1.6rem;
  font-weight: 300;
  line-height: 1.25em;
  width: 100%;
  border: 1px solid $gray200;
  margin: 1em 0;

  &:hover {
    cursor: pointer;
  }

  .accordion-header-container {
    color: $gray700;
    display: flex;
    justify-content: space-between;
    padding: 1.25em 1em;

    pn-icon {
      &:hover {
        cursor: pointer;
      }
    }
  }

  .accordion-content-container {
    padding: 1.25em 1em;
  }
}
</style>
